import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import { PressCards } from '../components/PressCards';
import { SectionWrapper } from '../components/SectionWrapper';
import { PressHeroSection } from '../sections/press/PressHeroSection';

import styles from './PressPage.module.css';

export function PressPage() {
  useDocumentTitle('Press');

  return (
    <div className={styles.page}>
      <PressHeroSection />
      <SectionWrapper background="soft" data-testid="press-section-articles">
        <PressCards />
      </SectionWrapper>
    </div>
  );
}
